import {
  GetEvidencePriorityFn,
  GetEvidencePriorityResponse,
} from "./evidence-priority.types";
import { EVIDENCE_PRIORITIES } from "./EvidencePriorities";

const getEvidencePriority: GetEvidencePriorityFn = async (values) => {
  const { id } = values || {};
  let data: GetEvidencePriorityResponse = {
    data: [],
  };

  return {
    data: EVIDENCE_PRIORITIES,
  };
};

export const EvidencePriorityAPI = {
  get: getEvidencePriority,
};
